import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useCompanies } from "../../../../common/api/useCompanies";
import { Dropdown, Typography } from "../../../../common/components";
import { Modal } from "../../../../common/components/Modal";
import { Item } from "../../../../common/models";
import { entityToItem } from "../../../../common/utils";
import { STEPS } from "../../constants";
import { useSetUpSpacesStore } from "../../store";
import { DialogStepper } from "../DialogStepper";

interface SelectCompanyProps {
    selectedCompany?: Item;
    onSelectCompany: (value: Item) => void;
}

const SelectCompany = (props: SelectCompanyProps) => {
    const { selectedCompany, onSelectCompany } = props;

    const { toggleVisibility, setStep } = useSetUpSpacesStore();

    const { t } = useTranslation(["common", "setUpSpaces"]);

    const { companies } = useCompanies();
    const companiesItems = useMemo(
        () => companies.map(entityToItem),
        [companies]
    );

    const handleClickNext = () => {
        if (!selectedCompany) {
            return;
        }

        setStep(STEPS.SET_LOCATION);
    };

    return (
        <Modal
            title={t("setUpSpaces:location.title") || ""}
            isOpen
            hasOkButton
            isOkButtonDisabled={!selectedCompany}
            okText={t("common:next") || ""}
            onClickClose={toggleVisibility}
            onClickOk={handleClickNext}
            className="max-w-full"
        >
            <div className="flex flex-col gap-4">
                <DialogStepper activeStep={STEPS.SET_COMPANY} />
                <Typography>
                    {t("setUpSpaces:company.chooseCompany")}
                </Typography>
                <div>
                    <label>{t("common:name")}*</label>
                    <Dropdown
                        options={companiesItems}
                        value={selectedCompany}
                        filter
                        onChange={(event) => onSelectCompany(event.value)}
                        className="w-full"
                    />
                </div>
            </div>
        </Modal>
    );
};

export default SelectCompany;
